import { GraphQL, GraphQLPagedQueryData, GraphQLQueryData } from "@rpi/openapi-api";
import { CellRoute } from "../../components/cells/CellLink";
import { CellOrganization } from "../../components/cells/CellOrganization";
import { RpiTableColumns } from "../../rpi-core/table/RpiTable";
import { createEntityColumn } from "../../rpi-core/table/RpiTableHelpers";
import { formatDate } from "../../utils/date.util";
import { dashboardUserRoleLabel } from "../../utils/graphql.util";

const dashboardUserColumn = createEntityColumn<GraphQL.DashboardUserResponse, GraphQL.DashboardUserSearchFields>();

export const DashboardUserColumn = {
  customer: dashboardUserColumn<"customer">({
    header: "Organization",
    sortKey: GraphQL.DashboardUserSearchFields.CustomerPublicId,
    cell: ({ row }) => <CellOrganization customer={row.customer} />,
    size: 200,
  }),
  email: dashboardUserColumn<"email">({
    header: "Email",
    accessor: "email",
    sortKey: GraphQL.DashboardUserSearchFields.Email,
    size: 300,
  }),
  role: dashboardUserColumn<"role">({
    header: "Role",
    accessor: "role",
    sortKey: GraphQL.DashboardUserSearchFields.Role,
    cell: ({ row }) => dashboardUserRoleLabel(row.role),
    size: 150,
  }),
  status: dashboardUserColumn<"disabled">({
    header: "Status",
    accessor: "disabled",
    sortKey: GraphQL.DashboardUserSearchFields.Disabled,
    cell: ({ row }) => (row.disabled ? "Inactive" : "Active"),
  }),
  createdAt: dashboardUserColumn<"createdAt">({
    header: "User Since",
    accessor: "createdAt",
    sortKey: GraphQL.DashboardUserSearchFields.CreatedAt,
    cell: ({ row }) => formatDate(row.createdAt),
    size: 170,
  }),
  name: dashboardUserColumn<"id" | "firstName" | "lastName">({
    header: "Name",
    accessor: "firstName",
    cell: ({ row }) => {
      const name = [row.firstName, row.lastName].filter(Boolean).join(" ") || "—";
      return <CellRoute route={["dashboard-user", { id: row.id }]}>{name}</CellRoute>;
    },
    size: 200,
  }),
  username: dashboardUserColumn<"username">({
    header: "Username",
    accessor: "username",
    sortKey: GraphQL.DashboardUserSearchFields.Username,
    size: 200,
  }),
};

export const dashboardUserColumns: RpiTableColumns<GraphQLPagedQueryData<GraphQL.DashboardUsersQuery>> = (user) => [
  DashboardUserColumn.name,
  DashboardUserColumn.username,
  user.is.SUPER_ADMIN && DashboardUserColumn.customer,
  DashboardUserColumn.email,
  DashboardUserColumn.createdAt,
  DashboardUserColumn.role,
];

export const customerDashboardUserColumns: RpiTableColumns<
  NonNullable<NonNullable<GraphQLQueryData<GraphQL.CustomerQuery>["dashboardUsers"]>[number]>
> = [DashboardUserColumn.email, DashboardUserColumn.role, DashboardUserColumn.status, DashboardUserColumn.createdAt];
